import React, { useState, useEffect } from 'react';
import { Tabs, Table, Button, message, InputNumber, Modal, Spin } from 'antd';
import { PlusOutlined, DeleteOutlined, PlusCircleOutlined, SaveOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons';
import axios from 'axios';
import '@lottiefiles/lottie-player';
import '../../App.css'; // or the path to your global CSS


const { TabPane } = Tabs;

const PlayerStatsTable = ({ gameId, game }) => {
  const [homeTeamStats, setHomeTeamStats] = useState([]);
  const [awayTeamStats, setAwayTeamStats] = useState([]);
  const [loading, setLoading] = useState(false);
  const [processing, setProcessing] = useState(false); // To control the spinner modal
  const [activeTab, setActiveTab] = useState(game.home_team); // Default to home team

  // Fetch player stats on component mount
  useEffect(() => {
    const fetchPlayerStats = async () => {
      try {
        const access_token = localStorage.getItem('access_token');
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/games/${gameId}/std_player_stats/`,
          {
            headers: { Authorization: `Bearer ${access_token}` },
          }
        );

        const stats = response.data;

        // Split stats by team
        setHomeTeamStats(stats.filter((stat) => stat.team === game.home_team));
        setAwayTeamStats(stats.filter((stat) => stat.team === game.away_team));
      } catch (error) {
        message.error('Failed to fetch player stats');
        console.error('Error fetching player stats:', error);
      }
    };

    fetchPlayerStats();
  }, [gameId, game]);

  // NEW: IncrementStatModal Component
  const IncrementStatModal = ({ visible, onClose, onIncrement, homeTeamStats, awayTeamStats, game }) => {
    const [selectedPlayer, setSelectedPlayer] = useState(null);
    const [selectedStat, setSelectedStat] = useState(null);
  
    const handleIncrement = () => {
      if (selectedPlayer && selectedStat) {
        onIncrement(selectedPlayer.team, selectedPlayer.player_number, selectedStat);
        message.success(`Stat "${selectedStat.toUpperCase()}" incremented for Player ${selectedPlayer.player_number} of ${selectedPlayer.team}!`);
        setSelectedPlayer(null); // Reset selection
        setSelectedStat(null); // Reset stat selection
      } else {
        message.error('Please select both a player and a stat to increment.');
      }
    };
  
    return (
      <Modal
          visible={visible}
          onCancel={onClose}
          footer={null}
          title={
            <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '16px' }}>
              LIVE STAT INPUT
            </div>
          }
          centered
        >
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
          <div style={{ width: '100%', marginBottom: '20px' }}>
            <h3>Team 1: {game.home_team}</h3>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
              {homeTeamStats.map((player) => (
                <Button
                  key={player.player_number}
                  type={selectedPlayer?.player_number === player.player_number && selectedPlayer?.team === game.home_team ? "primary" : "default"}
                  onClick={() => setSelectedPlayer({ team: game.home_team, player_number: player.player_number })}
                >
                  {player.player_number}
                </Button>
              ))}
            </div>
          </div>
  
          <div style={{ width: '100%', marginBottom: '20px' }}>
            <h3>Team 2: {game.away_team}</h3>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
              {awayTeamStats.map((player) => (
                <Button
                  key={player.player_number}
                  type={selectedPlayer?.player_number === player.player_number && selectedPlayer?.team === game.away_team ? "primary" : "default"}
                  onClick={() => setSelectedPlayer({ team: game.away_team, player_number: player.player_number })}
                >
                  {player.player_number}
                </Button>
              ))}
            </div>
          </div>
  
          <div style={{ width: '100%', textAlign: 'center', marginBottom: '20px' }}>
            <div
  style={{
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))', // Adjusted to auto-fit for dynamic rows
    gap: '10px',
  }}
>
  {[
    { label: 'FTM', icon: <><PlusOutlined /> 1P <CheckOutlined /></>, color: 'lightgreen' },
    { label: 'FTA', icon: <>1P <CloseOutlined /></>, color: '#ffcccc' },

    { label: 'OREB', icon: null, color: 'lightblue' },
    { label: 'DREB', icon: null, color: 'lightblue' },


    { label: 'FGM', icon: <><PlusOutlined /> 2P <CheckOutlined /></>, color: 'lightgreen' },
    { label: 'FGA', icon: <>2P <CloseOutlined /></>, color: '#ffcccc' },
    { label: 'AST', icon: null, color: '#f0fff0' },
    { label: 'TOV', icon: null, color: '#FFB347' },


    { label: '3PM', icon: <><PlusOutlined /> 3P <CheckOutlined /></>, color: 'lightgreen' },
    { label: '3PA', icon: <>3P <CloseOutlined /></>, color: '#ffcccc' },

    { label: 'STL', icon: null, color: '#FFFACD' },
    { label: 'BLK', icon: null, color: '#FFFACD' },

  ].map((stat) => (
    <Button
      key={stat.label}
      onClick={() => setSelectedStat(stat.label.toLowerCase())}
      style={{
        height: '50px',
        backgroundColor: stat.color,
        color: selectedStat === stat.label.toLowerCase() ? 'white' : 'black',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '5px',
        border: selectedStat === stat.label.toLowerCase() ? `2px solid ${stat.color}` : '1px solid #d9d9d9',
        boxShadow: selectedStat === stat.label.toLowerCase() ? '0 0 10px rgba(0,0,0,0.5)' : 'none',
        transition: 'all 0.3s ease',
      }}
    >
      {stat.icon || stat.label}
    </Button>
  ))}
</div>
          </div>
  
          <Button type="primary" onClick={handleIncrement} icon={<PlusCircleOutlined />}>
            ADD
          </Button>
        </div>
      </Modal>
    );
  };

  // NEW: Add state to manage modal visibility
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleIncrement = (team, playerNumber, stat) => {
    const updateStats = (stats) =>
      stats.map((statObj) => {
        if (statObj.player_number === playerNumber) {
          let updatedStat = { ...statObj };

          // Increment selected stat
          updatedStat[stat] = (updatedStat[stat] || 0) + 1;

          // Increment related stats
          if (stat === 'fgm') {
            updatedStat['fga'] = (updatedStat['fga'] || 0) + 1; // Increment FGA
          } else if (stat === '3pm') {
            updatedStat['three_pm'] = (updatedStat['three_pm'] || 0) + 1; // Increment 3PM
            updatedStat['three_pa'] = (updatedStat['three_pa'] || 0) + 1; // Increment 3PA
            updatedStat['fgm'] = (updatedStat['fgm'] || 0) + 1; // Increment FGM
            updatedStat['fga'] = (updatedStat['fga'] || 0) + 1; // Increment FGA
          } else if (stat === '3pa') {
            updatedStat['three_pa'] = (updatedStat['three_pa'] || 0) + 1; // Increment 3PA
            updatedStat['fga'] = (updatedStat['fga'] || 0) + 1; // Increment FGA
          } else if (stat === 'ftm') {
            updatedStat['fta'] = (updatedStat['fta'] || 0) + 1; // Increment FTA
          }

          return updatedStat;
        }
        return statObj;
      });

    if (team === game.home_team) {
      setHomeTeamStats(updateStats(homeTeamStats));
    } else {
      setAwayTeamStats(updateStats(awayTeamStats));
    }
  };

  // Create a default row
  const createDefaultRow = (team) => ({
    id: `temp_${Date.now()}`,
    player_number: '',
    team,
    game_id: gameId,
    fgm: 0,
    fga: 0,
    three_pm: 0,
    three_pa: 0,
    ftm: 0,
    fta: 0,
    oreb: 0,
    dreb: 0,
    ast: 0,
    tov: 0,
    stl: 0,
    blk: 0,
  });

  const handleAddRow = () => {
    if (activeTab === game.home_team) {
      setHomeTeamStats((prevStats) => [...prevStats, createDefaultRow(game.home_team)]);
    } else {
      setAwayTeamStats((prevStats) => [...prevStats, createDefaultRow(game.away_team)]);
    }
  };
  
  const handleDeleteRow = (index) => {
    if (activeTab === game.home_team) {
      setHomeTeamStats((prevStats) => prevStats.filter((_, i) => i !== index));
    } else {
      setAwayTeamStats((prevStats) => prevStats.filter((_, i) => i !== index));
    }
  };

  const handleCellChange = (value, record, field) => {
    const updateStats = (stats) =>
      stats.map((stat) =>
        stat.id === record.id ? { ...stat, [field]: value } : stat
      );
  
    if (activeTab === game.home_team) {
      setHomeTeamStats(updateStats(homeTeamStats));
    } else {
      setAwayTeamStats(updateStats(awayTeamStats));
    }
  };

  const handleSave = async () => {
    try {
      setProcessing(true); // Show spinner modal
      const access_token = localStorage.getItem('access_token');
  
      if (!access_token) {
        message.error('Access token not found, please log in again.');
        return;
      }
  
      const combinedStats = [...homeTeamStats, ...awayTeamStats];
  
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/games/${gameId}/create_stats/`,
        combinedStats,
        {
          headers: { Authorization: `Bearer ${access_token}` },
        }
      );
  
      message.success('Player stats saved successfully!');
    } catch (error) {
      if (error.response && error.response.status === 401) {
        message.error('Unauthorized: Please log in again.');
      } else {
        message.error('Failed to save player stats');
      }
      console.error('Error saving player stats:', error);
    } finally {
      setProcessing(false); // Hide spinner modal
    }
  };

  // Define table columns
  const columns = [
    {
      title: () => (
        <PlusOutlined
          onClick={handleAddRow}
          style={{
            fontSize: '18px',
            cursor: 'pointer',
            display: 'flex',
            justifyContent: 'center',
          }}
        />
      ),
      dataIndex: 'actions',
      key: 'actions',
      render: (_, record, index) => (
        <DeleteOutlined
          onClick={() => handleDeleteRow(index)}
          style={{
            fontSize: '18px',
            cursor: 'pointer',
            color: 'red',
            display: 'flex',
            justifyContent: 'center',
          }}
        />
      ),
      width: 50,
    },
    {
      title: 'Player',
      dataIndex: 'player_number',
      key: 'player_number',
      render: (text, record) => (
        <InputNumber
          value={text}
          min={0}
          onChange={(value) => handleCellChange(value, record, 'player_number')}
          style={{
            width: '100%',
            backgroundColor: '#f5f5f5', 
            border: '1px solid #d9d9d9', 
            borderRadius: '4px',
          }}
        />
      ),
    },
    {
      title: 'FGM',
      dataIndex: 'fgm',
      key: 'fgm',
      render: (text, record) => (
        <InputNumber
          value={text}
          min={0}
          onChange={(value) => handleCellChange(value, record, 'fgm')}
          style={{ width: '100%' }}
        />
      ),
    },
    {
      title: 'FGA',
      dataIndex: 'fga',
      key: 'fga',
      render: (text, record) => (
        <InputNumber
          value={text}
          min={0}
          onChange={(value) => handleCellChange(value, record, 'fga')}
          style={{ width: '100%' }}
        />
      ),
    },
    {
      title: '3PM',
      dataIndex: 'three_pm',
      key: 'three_pm',
      render: (text, record) => (
        <InputNumber
          value={text}
          min={0}
          onChange={(value) => handleCellChange(value, record, 'three_pm')}
          style={{ width: '100%' }}
        />
      ),
    },
    {
      title: '3PA',
      dataIndex: 'three_pa',
      key: 'three_pa',
      render: (text, record) => (
        <InputNumber
          value={text}
          min={0}
          onChange={(value) => handleCellChange(value, record, 'three_pa')}
          style={{ width: '100%' }}
        />
      ),
    },
    {
      title: 'FTM',
      dataIndex: 'ftm',
      key: 'ftm',
      render: (text, record) => (
        <InputNumber
          value={text}
          min={0}
          onChange={(value) => handleCellChange(value, record, 'ftm')}
          style={{ width: '100%' }}
        />
      ),
    },
    {
      title: 'FTA',
      dataIndex: 'fta',
      key: 'fta',
      render: (text, record) => (
        <InputNumber
          value={text}
          min={0}
          onChange={(value) => handleCellChange(value, record, 'fta')}
          style={{ width: '100%' }}
        />
      ),
    },
    {
      title: 'OREB',
      dataIndex: 'oreb',
      key: 'oreb',
      render: (text, record) => (
        <InputNumber
          value={text}
          min={0}
          onChange={(value) => handleCellChange(value, record, 'oreb')}
          style={{ width: '100%' }}
        />
      ),
    },
    {
      title: 'DREB',
      dataIndex: 'dreb',
      key: 'dreb',
      render: (text, record) => (
        <InputNumber
          value={text}
          min={0}
          onChange={(value) => handleCellChange(value, record, 'dreb')}
          style={{ width: '100%' }}
        />
      ),
    },
    {
      title: 'AST',
      dataIndex: 'ast',
      key: 'ast',
      render: (text, record) => (
        <InputNumber
          value={text}
          min={0}
          onChange={(value) => handleCellChange(value, record, 'ast')}
          style={{ width: '100%' }}
        />
      ),
    },
    {
      title: 'TOV',
      dataIndex: 'tov',
      key: 'tov',
      render: (text, record) => (
        <InputNumber
          value={text}
          min={0}
          onChange={(value) => handleCellChange(value, record, 'tov')}
          style={{ width: '100%' }}
        />
      ),
    },
    {
      title: 'STL',
      dataIndex: 'stl',
      key: 'stl',
      render: (text, record) => (
        <InputNumber
          value={text}
          min={0}
          onChange={(value) => handleCellChange(value, record, 'stl')}
          style={{ width: '100%' }}
        />
      ),
    },
    {
      title: 'BLK',
      dataIndex: 'blk',
      key: 'blk',
      render: (text, record) => (
        <InputNumber
          value={text}
          min={0}
          onChange={(value) => handleCellChange(value, record, 'blk')}
          style={{ width: '100%' }}
        />
      ),
    },
  ];

  const dataSource = activeTab === game.home_team ? homeTeamStats : awayTeamStats;

  const SpinModal = ({ visible }) => (
    <Modal
      visible={visible}
      footer={null}
      closable={false}
      centered
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          padding: '20px',
          height: '250px', // Optional: Ensure enough height for centering
        }}
      >
        <lottie-player
          src="/Animation - 1737848203626.json"
          background="transparent"
          speed="1"
          style={{ width: '200px', height: '200px' }}
          loop
          autoplay
        ></lottie-player>
        <p style={{ marginTop: '20px', fontSize: '16px' }}>
          Crunching the numbers and analyzing the stats! Your analytics will be ready in just a moment...
        </p>
      </div>
    </Modal>
  );
  

  return (
    <div style={{ padding: '20px', height: '100vh' }}>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
        <Button
          type="primary"
          className="attention-button" // Add animation class
          onClick={() => setIsModalOpen(true)}
        >
          Live Stat Input
        </Button>
      </div>

      {!loading && (
      <Tabs
        defaultActiveKey={game.home_team}
        onChange={setActiveTab}
        type="card"
        style={{ marginBottom: '20px' }}
      >
        <TabPane tab={game.home_team} key={game.home_team}>
          <Table
            dataSource={dataSource}
            columns={columns}
            rowKey={(record) => record.player_number || `new_${Math.random()}`}
            pagination={false}
            bordered
            scroll={{ x: '100%', y: '60vh' }} // Restrict height to fit page
          />
        </TabPane>
        <TabPane tab={game.away_team} key={game.away_team}>
          <Table
            dataSource={dataSource}
            columns={columns}
            rowKey={(record) => record.player_number || `new_${Math.random()}`}
            pagination={false}
            bordered
            scroll={{ x: '100%', y: '60vh' }} // Restrict height to fit page
          />
        </TabPane>
      </Tabs>
      )}

      <Button
        type="primary"
        onClick={handleSave}
        loading={loading}
        style={{ marginTop: '10px', alignSelf: 'center', width: '200px' }}
        icon={<SaveOutlined />}
      >
        Save Stats
      </Button>
      <IncrementStatModal
        visible={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onIncrement={handleIncrement}
        homeTeamStats={homeTeamStats}
        awayTeamStats={awayTeamStats}
        game={game}
      />

    <SpinModal visible={processing} /> 
    </div>
  );
};

export default PlayerStatsTable;
